// /api/v1/staff/available-booking-online

import { useState } from 'react';
import { IResponseDataBody } from 'services/response';
import { IStaffItemData } from 'services/shop/types/staff';
import appointmentApis from '../services/apis';
import { bookingV2LoadingRef } from './Loading';
import { ANY_BODY_ID_STORE_LIST } from 'features/booking/services/constants';
type IInquiryCustomerHandler = {
  onStart?: () => void;
  onDone?: (data: IStaffItemData[]) => void;
};
const useQueryAvailableBooking = (handler?: IInquiryCustomerHandler): [IStaffItemData[], (date: string, customer_id?: string) => Promise<void>] => {
  const [data, setData] = useState<IStaffItemData[]>([]);
  const fetch = async (date: string, customer_id?: string) => {
    bookingV2LoadingRef.current?.open();
    handler?.onStart?.();
    try {
      const res: IResponseDataBody<IStaffItemData[]> = await appointmentApis.availableBookingOnline({
        customer_id,
        date,
      });
      const resData = res?.data?.data;
      if (resData) {
        const staffs = res.data.data;
        staffs.map(s => {
          if (s.anyBody) {
            ANY_BODY_ID_STORE_LIST.push(s.id);
          }
        });
        setData(staffs);
        handler?.onDone?.(staffs);
      } else {
        handler?.onDone?.([]);
        setData([]);
      }
    } catch (error) {
      handler?.onDone?.([]);
      setData([]);
    } finally {
      bookingV2LoadingRef.current?.close();
    }
  };

  return [data, fetch];
};

export default useQueryAvailableBooking;
